import { RootState } from '@reducers';

export const selectCarPolicyRenewal = (state: RootState) => state.userDashboardRouteReducer.policyRenewalReducer.carPolicyRenewalReducer;
